<template lang="">
    <div class="card h-100">
    <div v-if="completeInfo" id="modal-scoped">
        <div>
            <h3 class="card-title mb-2 mt-2 title pl-2">
                Votre profil
            </h3>
            <h5 class="card-title mb-2 mt-2 text-dark pl-2">{{$t('message.completeprofil')}} <strong class="colorRed">(*obligatoire)</strong></h5>
        </div>
        
       
        <b-form>
                <b-container>
                        <div>
                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                                id="lastName-group"
                                :label="$t('message.lastName')"
                                label-for="lastName"
                                description="">
                            <b-form-input
                                id="lastName"
                                class="mb--3 mt--1"
                                v-model="$v.form.user.nom.$model"
                                :state="$v.form.user.nom.$dirty ? !(errorshasField('nom') || $v.form.user.nom.$error) : null"
                                type="text"
                                required
                                placeholder=""
                                @focus="clearErrorField('nom')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="!$v.form.user.nom.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                {{ getErrorsField('nom') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                                id="firstName-group"
                                :label="$t('message.firstName')"
                                label-for="firstName"
                                description="">
                            <b-form-input
                                id="lastName"
                                class="mb--3 mt--1"
                                v-model="$v.form.user.prenom.$model"
                                :state="$v.form.user.prenom.$dirty ? !(errorshasField('prenom') || $v.form.user.prenom.$error) : null"
                                type="text"
                                required
                                placeholder=""
                                @focus="clearErrorField('prenom')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="!$v.form.user.prenom.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('prenom')">
                                {{ getErrorsField('prenom') }}
                            </b-form-invalid-feedback>

                        </b-form-group>

                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                            label-size="lg" 
                            id="sexe-group"
                            :label="$t('message.gender')"
                            label-for="gender">
                            <b-form-select
                                id="gender"
                                class="mb--3 mt--1"
                                v-model="$v.form.sexe.$model"
                                :state="$v.form.sexe.$dirty ? !(errorshasField('sexe') || $v.form.sexe.$error) : null"
                                :options="sexes"
                                
                                @focus="clearErrorField('sexe')"
                            ></b-form-select>

                            <b-form-invalid-feedback v-if="!$v.form.sexe.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('sexe')">
                                {{ getErrorsField('sexe') }}
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                                id="telephone-group"
                                label="Tel"
                                label-for="telephone">
                            <b-form-input
                                id="telephone"
                                class="mb--3 mt--1"
                                v-model="$v.form.user.telephone.$model"
                                :state="$v.form.user.telephone.$dirty ? !(errorshasField('telephone') || $v.form.user.telephone.$error) : null"
                                required
                                placeholder=""
                                @focus="clearErrorField('telephone')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="!$v.form.user.telephone.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-if="!$v.form.user.telephone.integer">
                                {{ $t('message.integer', { n: 9 }) }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-if="!$v.form.user.telephone.minLength">
                                {{ $t('message.minCharacters', { n: 9 }) }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                {{ getErrorsField('telephone') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                        
                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                                id="single-group"
                                :label="$tc('message.countries', 1)"
                                label-for="single">
                            <!-- Options -->
                        <select id="single"  v-model="$v.form.user.pays.$model" required class="form-control">
                                <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                    {{ item.text }}
                                </option>
                            </select>

                            <b-form-invalid-feedback v-if="errorshasField('pays')">
                                {{ getErrorsField('pays') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="!$v.form.user.pays.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                        </b-form-group>
                        
                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                                id="ville-group"
                                :label="$tc('message.cities', 1)"
                                label-for="ville">
                            <b-form-input
                                    id="ville"
                                    class="mb--3 mt--1"
                                    v-model="$v.form.user.ville.$model"
                                    :state="$v.form.user.ville.$dirty ? !(errorshasField('ville') || $v.form.user.ville.$error) : null"
                                    @focus="clearErrorField('ville')"
                                    required
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errorshasField('ville')">
                                {{ getErrorsField('ville') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="!$v.form.user.ville.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4" 
                                id="quartier-group"
                                :label="$t('message.street')"
                                label-for="quartier">
                            <b-form-input
                                    id="quartier"
                                    class="mb--3 mt--1"
                                    v-model="$v.form.user.quartier.$model"
                                    :state="$v.form.user.quartier.$dirty ? !(errorshasField('quartier') || $v.form.user.quartier.$error) : null"
                                    @focus="clearErrorField('quartier')"
                                    required
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                {{ getErrorsField('quartier') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="!$v.form.user.quartier.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4"    
                                id="code_postal-group"
                                :label="$t('message.zipCode')"
                                label-for="code_postal">
                            <b-form-input
                                    id="code_postal"
                                    class="mb--3 mt--1"
                                    v-model="$v.form.user.code_postal.$model"
                                    :state="$v.form.user.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.user.code_postal.$error) : null"
                                    @focus="clearErrorField('code_postal')"
                                    required
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                {{ getErrorsField('code_postal') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="!$v.form.user.code_postal.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group
                            label-cols="12" 
                            label-cols-lg="4"    
                                id="adresse-group"
                                :label="$t('message.address')"
                                label-for="adresse">
                            <b-form-input
                                    id="adresse"
                                    class="mb--3 mt--1"
                                    v-model="$v.form.user.adresse.$model"
                                    :state="$v.form.user.adresse.$dirty ? !(errorshasField('adresse') || $v.form.user.adresse.$error) : null"
                                    @focus="clearErrorField('adresse')"
                                    required
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="!errorshasField('adresse')">
                                {{ getErrorsField('adresse') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="$v.form.user.adresse.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    </b-container>
                    <div class="row justify-content-center" >
                        <!-- <div class="col-6">
                            <button class="btn btn-outline-dark" @click="onSubmit">Précedent</button>
                        </div> -->
                        <div  :class="[mobileView ? 'w-100 px-2' : 'px-2']">
                            <span class="btn btn-success w-100" @click="onSubmit">Suivant</span>
                        </div>
                    </div>
        </b-form>
        <div class="row d-flex justify-content-center pb-4">
                        <div :class="['arrow-circle-success mr-1']"></div>
                        <div :class="['arrow-circle-dark mx-2']"></div>
                        <!-- <div :class="['arrow-circle-dark mx-2']"></div>
                        <div :class="['arrow-circle-dark mx-2']"></div> -->
        </div>
    </div>

    <div class="container-fluid" v-else-if="mesSouscriptions">
        <div class="card-header mb-2 mt-2 title">
            <a @click="completeInfo=true,mesSouscriptions=false,addPatient=false,consentement=false,getStarted=false"><i class="fa fa-arrow-left" aria-hidden="true" v-if="mobileView"></i></a>
            <h3 class="card-title mb-2 mt-2 title pl-2">
                {{ $t('message.SouscripteurDashboard') }}
            </h3>
            <p class="pl-2">Veillez selectionner une CIM et ajouter un patient SVP <strong class="colorRed">(*obligatoire)</strong>. </p>
        </div>

        <div class="row">
                    <div class="col-md-4 w-100" v-for="(value, key) in mCommandes" :key="key"> <!-- v-for="(ligne_temp, index) in filterTrajet" :key="index" @click="changeColor(index)" v-model="motif" -->
                        <div v-b-toggle="'collapse'+key" class="mt-3 w-100"  v-if="value.nombre_restant > 0"> <!-- ="'collapse'+index" :class="{ 'trajet__active' : selectTrajet }"-->
                        
                            <span class="border border-5 rounded py-3 px-1 row CimsList cimHeight"  id="disabled-wrapper" @click="onNextPatient(),idCim=value.id, description=value.type_contrat.description_fr">
                                <!-- <i class="fa fa-calendar text-primary" aria-hidden="true"></i> -->
                                <div class="col-6 col-md-6 text-default">
                                    <h5>{{truncate(value.type_contrat.description_fr, 15) }}</h5>
                                    <h5 class="font-weight-light colorGrey"><i class="fa fa-circle-red" aria-hidden="true"></i>{{value.nombre_restant}}/{{value.nombre_paye}}</h5>
                                </div>
                                <div class="col-6 col-md-6 pt-2">
                                        <span class="border border-primary bg-primary rounded text-white py-1 px-3 float-right"><i class="fa fa-user-plus pr-2" aria-hidden="true"></i>Patient</span>
                                </div>
                            </span>
                        
                        </div>
                        <div class="col-sm-3 mt-3"  v-else> <!-- ="'collapse'+index" :class="{ 'trajet__active' : selectTrajet }"--> 
                        <span class="border border-5 transparentGrey rounded py-3 px-1 row" @click="">
                            <!-- <i class="fa fa-calendar text-primary" aria-hidden="true"></i> -->
                            <div class="col text-default colorGrey"> <h5>{{truncate(value.type_contrat.description_fr, 20) }}</h5>
                                <h5 class="font-weight-light colorGrey"><i class="fa fa-circle-red" aria-hidden="true"></i>{{value.nombre_restant}}/{{value.nombre_paye}}</h5>
                            </div>
                            <div class="col pt-2">
                                    <span class="border border-secondary  spanGrey rounded py-1 px-3 float-right">Complèt</span>
                            </div>
                        </span>
                    
                        </div>
            </div>
        </div>
      
        <div class="d-flex justify-content-md-end justify-content-center pr-md-5 mt-3">
                        <div class="d-none d-lg-block px-2">
                            <button class="btn btn-outline-dark" @click="completeInfo=true,mesSouscriptions=false,addPatient=false,consentement=false,getStarted=false">Précedent</button>
                        </div>
                        <div :class="[mobileView ? 'w-100 px-2' : 'px-2']">
                            <button class="btn btn-success w-100" @click="completeInfo=false,mesSouscriptions=false,addPatient=true,consentement=false,getStarted=false,hideView=true,showPage=true">Suivant</button>
                        </div>
                    </div>
        
        <div class="row d-flex justify-content-center pb-4">
                        <div :class="['arrow-circle-dark mr-1']"></div>
                        <div :class="['arrow-circle-success mx-2']"></div>
                        <!-- <div :class="['arrow-circle-dark mx-2']"></div>
                        <div :class="['arrow-circle-dark mx-2']"></div> -->
        </div>
    </div>
    <div class="card" v-else-if="addPatient">
        <!-- <h3 class="card-title pl-2 mb-2 mt-2 title">
            Ajouter un patient
        </h3>
                   -->
        <firstaddpatient :package_id='idCim' :description_fr="description" :circleView="hideView" @getNext="completeInfo=false,mesSouscriptions=false,addPatient=false,consentement=false,getStarted=true" @getPrevious="completeInfo=false,mesSouscriptions=true,addPatient=false,consentement=false,onHome=false"/>   
    </div>
   <!--  <div class="card" v-else-if="consentement">
        <div class="card-header title bg-transparent">
            <a class="" @click="completeInfo=false,mesSouscriptions=false,addPatient=true,consentement=false,getStarted=false"><i class="fa fa-arrow-left" aria-hidden="true" v-if="mobileView"></i></a>
        </div>
        <div class="container">
            <h3 class="card-title text-center mb-2 mt-2 title">
                Signature du consentement éclairé
            </h3>
            <div class="row">
                <div class="col-md-12">
                    <p>Consulter le <a style="color: #2dcecc;" target="_blank" href="https://www.medicasure.com/particuliers/consentement-eclaire">Consentement éclairé</a> et apporter votre signature ci-dessous</p>
                </div>
                <div class="col-md-12 mb-2">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" value="1" v-model="consentement" id="consentement_eclaire" name="consentement">
                        <label class="custom-control-label" for="consentement_eclaire">Je valide le consentement éclairé</label>
                    </div>
                </div>
                <div class="col-md-12 border w-100 h-100" v-if="consentement">
                    <img :src="dataUrl" class="img-fluid" v-if="dataUrl!= null && !disabled">
                    <vueSignature v-else ref="signature" :sigOption="option" :w="'350px'" :h="'300px'"></vueSignature> 
                </div>
            </div>
            <div class="col-md-12 text-center mt-3">
                <button @click="save" class="btn btn-primary">Enregistrer</button> -->
             <!--    <button @click="clear" class="btn btn-secondary">Modifier</button>
                <button @click="undo" class="btn btn-danger">Effacer</button>
            </div>
            
        </div>
        <div class="d-flex justify-content-md-end justify-content-center mt-4 pr-md-5">
                        <div class="p-2"  v-if="!mobileView">
                            <button class="btn btn-outline-dark" @click="completeInfo=false,mesSouscriptions=false,addPatient=true,consentement=false,getStarted=false">Précedent</button>
                        </div>
                        <div :class="[mobileView ? 'w-100 px-2' : 'px-2']">
                            <button class="btn btn-success w-100" @click="save()">Terminer</button>
                        </div>
        </div>
        <div class="row d-flex justify-content-center">
                        <div :class="['arrow-circle-dark mr-1']"></div>
                        <div :class="['arrow-circle-dark mx-2']"></div>
                        <div :class="['arrow-circle-dark mx-2']"></div>
                        <div :class="['arrow-circle-success mx-2']"></div>
        </div>
    </div> -->
    <div class="card" v-else-if="getStarted">
                <div class="row d-flex justify-content-center">
                        <div class="container">
                            <h3 class="card-title mb-2 mt-2 title">
                                Veuillez patienter SVP!!
                            </h3>
                            <h3> L'enregistrement de votre patient est en cours..</h3>
                            
                        </div>
                </div>
                <div class="row d-flex justify-content-center mt-3">
                    <!-- <div :class="['arrow-circle-dark mr-1']"></div>
                    <div :class="['arrow-circle-dark mx-2']"></div>
                    <div :class="['arrow-circle-success mx-2']"></div> -->
                    
                </div>
                <div class="row justify-content-center my-4 pr-2" role="status">
                    <div class="loading"></div>
                </div> 
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
//import SlimSelect from 'slim-select';
import moment from "moment";
import { required, email, integer, minLength } from 'vuelidate/lib/validators';

import axios from 'axios';
import Swal from 'sweetalert2';
import Vue from 'vue';
import AppConfig from '../../constants/AppConfig';
import vueSignature from "vue-signature";
import SlimSelect from 'slim-select';
import firstaddpatient from "./../Subscribers/firstaddpatient"
import controlDoctors from '../../store/modules/control-doctors';
const numericValidator = string => (/^[0-9]+$/gi).test(string);

export default {
    name: "WelcomeMedsurlink",
    components:{
            vueSignature,
            firstaddpatient
        },
        props: ['onHome'],
    
    data() {
        return {
            mobileView:true,
            hideView:true,
            completeInfo:true,
            mesSouscriptions:false,
            addPatient:false,
            consentement:false,
            getStarted:false,
            showPage: true,
            option:{
				    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                disabled: JSON.parse(localStorage.getItem('user'))['signature'] == null ? true : false,
                dataUrl: JSON.parse(localStorage.getItem('user'))['signature'],
                consentement: 1,
                form: this.subscriber != null ? this.subscriber : {user: JSON.parse(localStorage.getItem('user')), sexe: JSON.parse(localStorage.getItem('user'))['souscripteur']['sexe']},
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                subscriber_id: JSON.parse(localStorage.getItem('user'))['slug'],
                signature: JSON.parse(localStorage.getItem('user'))['signature'],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },
                affiliateColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'type_contrat.description_fr',
                    },
                    {
                        field: 'nombre_restant',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'type_contrat.montant',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'created_at',
                        label: this.$i18n.t('message.email')
                    },
                ],
            }

    },
    computed: {
        ...mapGetters(["subscriber", 'hasAdminRole', "countries",
            'hasGestionnaireRole', 'hasSouscripteurRole', 'hasMedecinControleRole', 'hasPraticienRole', 'hasAssistante',
            "patients", "commandes"]), 
        mSubscriber: function () {
            /* if(this.subscriber.affiliation[0].nombre_restant > 1){
               this.$router.push({ name: 'add-patient-souscripteur'});
             }*/
            this.subscriber_id = this.subscriber.id;
            return this.subscriber;
        },
        mCommandes: function () {
            let restant = [];
            if (!_.isUndefined(this.commandes) && !_.isNull(this.commandes)) {
                restant = this.commandes;
            }

            return restant;
        },
        mCountries: function () {
            let cArray = [];

            _.forOwn(this.countries, function (value, key) {
                cArray.push({ text: value.name, value: value.name });
            });

            return cArray;
        },
        mAffiliate: function () {
            let pArray = [];
            _.forEach(this.patients, function (patient) {
                let p = {};

                if (typeof patient.user == 'object') {
                    if (!_.isUndefined(patient.dossier)) {
                        if (!_.isNull(patient.dossier)) {
                            p.nom = (patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase();
                            p.dossier = patient.dossier.numero_dossier;
                            p.email = patient.user.email;
                            p.telephone = patient.user.telephone;
                            p.age = patient.age;
                            p.nationalite = patient.user.nationalite;
                            p.ville = patient.user.ville;
                            p.pays = patient.user.pays;
                            p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                            p.id = patient.user.id;
                            p.slug = patient.user.slug;
                            p.adresse = patient.user.adresse;
                            p.fileSlug = patient.dossier.slug;
                            pArray.push(p);
                        }
                    }
                }
            });
            return pArray;
        },

        mSubscriberUserInformation: function () {
            if (typeof this.mSubscriber.user == 'object') {
                return this.mSubscriber.user;
            }
            return [];
        },

        fullName: function () {
            let prenom = this.mSubscriberUserInformation.prenom != null ? this.mSubscriberUserInformation.prenom : "";
            return this.getValue(prenom) + "  " + (this.getValue(this.mSubscriberUserInformation.nom)).toUpperCase();

        },

        rows: function () {
            if (typeof this.mSubscriber.patients == "object")
                return this.mSubscriber.patients.length;
            return 0;
        },

        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole;
        },
        
    },
    methods: {
            validateState(adresse) {
                const { $dirty, $error } = this.$v.form.user[adresse];
                return $dirty ? !$error : null;
                },
            truncate(str, n){
                return (str.length > n) ? str.slice(0, n-1) + '...' : str;
            },
            handleView() {
                this.mobileView = window.innerWidth <= 990;
            },

            // checkIfProfileComplete(){
            //     let user = JSON.parse(localStorage.getItem('user'));
            //     if(user.souscripteur.sexe == ''){
                    // this.$bvModal.show('modal-scoped');
                  //  }
              //  if(this.dataUrl == null){
                   // this.$bvModal.show('consentement');
            //     }
            // },
            goToPaiement :function(){

               this.$router.push({ name: 'paiement', params: { identifiant: (JSON.parse(localStorage.getItem('user')))['slug'] } });

            },

            gotToMesAffilies: function() {

                this.$router.push({ name: 'mesAffilies'});
                
            },

            addPatientToAffiliation: function() {
                let offres = [];
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                _.forOwn(this.commandes, function(value) {
                    if(value.nombre_restant >=0){
                        offres.push({ text: value.type_contrat.description_fr, value: value.id, id: value.type_contrat.offre_id});
                        
                    }
                });
                this.$router.push({ name: 'add-patient-souscripteur', params:{id: offres.id}});//params:{id: this.commandes.type_contrat.offre_id}
                
                }
                
                
            },

            GenerationFacture: affiliation => {
                axios.get(`${AppConfig.apiUrl}/impression/facture-offre/${affiliation.id}`).then(res => {
                    window.open(res.data.link, '_blank');
                }).catch(error => {
                    console.log('error ', error);
                })
            },

            getPatients() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPatients', { args : args });
            },

            onaffiliateRowClick(params){
                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                this.$router.push((this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug } })).href +  '#generale');

            },
            onNext: function(evt) {
                this.completeInfo=false,this.mesSouscriptions=true,this.addPatient=false,this.consentement=false,this.getStarted=false
            },
            onNextPatient: function(evt) {
                this.completeInfo=false,this.mesSouscriptions=false,this.addPatient=true,this.consentement=false,this.getStarted=false
            },
           onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        subscriber: this.form.user.slug,
                        sexe: this.form.sexe,
                        nom: this.form.user.nom,
                        prenom: this.form.user.prenom,
                        telephone: this.form.user.telephone,
                        ville: this.form.user.ville,
                        pays: this.form.user.pays,
                        adresse: this.form.user.adresse,
                        quartier: this.form.user.quartier,
                        code_postal: this.form.user.code_postal
                    };

                    let successMessage = this.$i18n.t('message.subscriberUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };
                    let loader = document.getElementById('bg-loader');
                    // loader.classList.remove("d-none");
                    this.$store.dispatch('updateSubscriber', { args, errorMessages, successMessage }).then(() => {
                        this.onNext();
                        loader.classList.add("d-none");
                        this.$bvModal.hide('modal-scoped');
                        this.$router.push({ name: 'SouscripteurDashboard', params: { } });
                        Swal.fire({
                            icon: 'success',
                            title:"Mise à jours",
                            text:"Vos informations d'identifications ont été envoyé par email à l'adresse "+JSON.parse(localStorage.getItem('user'))['email']
                        });
                    });
                }
            },
            // validateState(user) {
            //     const { $dirty, $error } = user;
            //     return $dirty ? !$error : null
            //     },
            getSubscriber() {
                let args = {
                    subscriber: this.subscriber_id
                };

                this.$store.dispatch("getSubscriber", { args });
            },

            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            getCommandes: function() {
                let args = {
                    souscripteur: (JSON.parse(localStorage.getItem('user')))['id']
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$store.dispatch('getCommandes', { args, errorMessages });
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
            /**
             * signature
             */
            
          
            save(){
                var _this = this;
                const formData = new FormData();
                //if((this.dataUrl!= null) && (!this.dataUrl.includes(".png"))){
                    const signature = _this.$refs.signature.save();
                    formData.append('signature', signature)
                //}
                formData.append('id', JSON.parse(localStorage.getItem('user'))['id'])
                formData.append('consentement', this.consentement ? 1 : 0)
                formData.append('souscripteur', 1)

                axios.post(`${AppConfig.apiUrl}/signature/user`, formData, {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'Authorization': "Bearer " + localStorage.getItem('ms-token')
                    }
                }).then(res => {
                   // this.$emit('getHome');
                    this.$bvModal.hide('consentement');
                    Vue.swal("Votre signature a été ajouter avec succès", '', 'success');
                    let user = JSON.parse(localStorage.getItem('user'));
                    user = {...user, signature: res.data.signature};
                    localStorage.setItem("user", JSON.stringify(user));
                    this.disabled = false;
                    this.dataUrl = res.data.signature;
                }).catch(error => {
                    console.log('error ', error);
                })

            },
            clear(){
                var _this = this;
                this.disabled = true;
                _this.$refs.signature.clear();
            },
            undo(){
                var _this = this;
                _this.$refs.signature.undo();
            }
        },

        validations: {
            form: {
                user: {
                    nom: {
                        required
                    },
                    prenom: {
                        required
                    },
                    telephone: {
                        required,
                        integer,
                        minLength: minLength(9)
                    },
                    email: {
                        required,
                        email
                    },
                    nationalite: {
                    },
                    ville: {
                        required
                    },
                    pays: {
                        required
                    },
                    quartier: {
                    },
                    code_postal: {
                    },
                    adresse: {
                    },
                },
                sexe: {
                    required
                },
                date_de_naissance: {
                    // required
                }
            }
        },
        created() {
            this.handleView();
            window.addEventListener('resize', this.handleView);
        },
        mounted() {
          this.getSubscriber();
            this.getPatients();
            this.getCountries();
           /*  new SlimSelect({
                select: '#single',
                placeholder: 'Select Country'
            }); */
            //this.$refs.tooltip.$emit('enable')
            // Retrieve list of subscribers
            this.getCommandes();
        }

    }
</script>
<style lang="">
    
</style>